import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class UsuarioService extends Service {
  recuperarUsuarioAplicacao (codUsuario) {
    return this.getUsuarioApi().recuperarUsuarioAplicacao(codUsuario);
  }

  // isUsuarioPrestador (codUsuario) {
  //   return this.getUsuarioApi().isUsuarioPrestador(codUsuario);
  // }

  // recuperarPrestador (codUsuario) {
  //   return this.getUsuarioApi().recuperarPrestador(codUsuario);
  // }

  renovarSessao () {
    return this.getUsuarioApi().renovarSessao();
  }
}

export default UsuarioService;
